import { Reducer } from 'interfaces'
import { SET_PUSH_NOTIFICATIONS_PLAYER_ID } from 'actions/pushNotificationsActions'
import { PushNotificationsAppState } from 'interfaces/pushNotifications'

const DEFAULT_STATE: PushNotificationsAppState = {
  playerId: null,
}

export const pushNotifications: Reducer<PushNotificationsAppState> = (prevState = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SET_PUSH_NOTIFICATIONS_PLAYER_ID: {
      return {
        ...prevState,
        playerId: action.payload.playerId,
      }
    }
  }
  return prevState
}

